import { render, staticRenderFns } from "./AddCertificateServer.vue?vue&type=template&id=55b333b6"
import script from "./AddCertificateServer.vue?vue&type=script&lang=js"
export * from "./AddCertificateServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports